import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 20px 20px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

  & > div {
    padding: 0;
    margin: 0;
    max-height: inherit;
  }

  .rdt_TableCol {
    background-color: var(--aside-background);

    padding: 16px;
    font-size: 0.875rem;
    text-align: left;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.43;
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    letter-spacing: 0.01071em;
    vertical-align: inherit;

    div {
      color: var(--purple) !important;
      font-weight: bold;
    }
  }

  .hemgRv {
    border-radius: 0 0 20px 20px;
  }

  .rdt_TableRow {
    font-size: 16px;
  }

  .rdt_TableCell {
    & > div {
      white-space: inherit;
    }
  }
`;
